import gql from "graphql-tag"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import fullUnauthedTenant from "../fragments/fullUnauthedTenant"

/** @deprecated: business query getting v2 tenant values, this is to be deprecated */
const query = gql`
  query BussinessBySubdomain($subdomain: String!) {
    businessBySubdomain(subdomain: $subdomain) {
      ...fullUnauthedTenant
    }
  }
  ${fullUnauthedTenant}
`

export const tenantBySubdomainKey = getQueryNames(query)[0]

export default query
